import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Phone, Send } from 'lucide-react';
import { useSite } from '../context/SiteContext';
import '../assets/LegalPage.css';
import './Contact.css';

const Contact = () => {
  const { siteName, fullAddress, email, phone } = useSite();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    orderNumber: '',
    subject: 'general',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setFormData({ name: '', email: '', orderNumber: '', subject: 'general', message: '' });
  };

  return (
    <div className="legal-page contact-page">
      <div className="legal-container">
        <header className="legal-header">
          <h1>Contact Us</h1>
          <p className="legal-meta">
            We're here to help. Reach out with questions about orders, products, or customer service.
          </p>
        </header>

        <div className="contact-layout">
          <div className="contact-info">
            <h3>Get in Touch</h3>
            <div className="contact-info-item">
              <MapPin size={20} />
              <div>
                <strong>Address</strong>
                <p>{fullAddress}</p>
              </div>
            </div>
            <div className="contact-info-item">
              <Mail size={20} />
              <div>
                <strong>Email</strong>
                <p><a href={`mailto:${email}`}>{email}</a></p>
              </div>
            </div>
            <div className="contact-info-item">
              <Phone size={20} />
              <div>
                <strong>Phone</strong>
                <p><a href={`tel:${phone}`}>{phone}</a></p>
              </div>
            </div>
            <div className="contact-hours">
              <strong>Customer Service Hours</strong>
              <p>Monday – Friday: 9:00 AM – 9:00 PM ET</p>
              <p>Saturday – Sunday: 10:00 AM – 6:00 PM ET</p>
            </div>
          </div>

          <div className="contact-form-wrapper">
            <h3>Send Us a Message</h3>
            {submitted ? (
              <div className="contact-success">
                <p>Thank you for contacting us! We'll respond within 1–2 business days.</p>
                <button type="button" onClick={() => setSubmitted(false)} className="contact-resend">
                  Send another message
                </button>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="contact-form-row">
                  <div className="contact-form-group">
                    <label htmlFor="name">Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="contact-form-group">
                    <label htmlFor="email">Email *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="contact-form-group">
                  <label htmlFor="orderNumber">Order Number (if applicable)</label>
                  <input
                    type="text"
                    id="orderNumber"
                    name="orderNumber"
                    value={formData.orderNumber}
                    onChange={handleChange}
                    placeholder="e.g., MAC12345678"
                  />
                </div>
                <div className="contact-form-group">
                  <label htmlFor="subject">Subject *</label>
                  <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  >
                    <option value="general">General Inquiry</option>
                    <option value="order">Order Status</option>
                    <option value="returns">Returns & Refunds</option>
                    <option value="shipping">Shipping</option>
                    <option value="product">Product Question</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div className="contact-form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={5}
                    required
                    placeholder="How can we help you?"
                  />
                </div>
                <button type="submit" className="contact-submit">
                  <Send size={18} />
                  Send Message
                </button>
              </form>
            )}
          </div>
        </div>

        <div className="legal-footer-links">
          <Link to="/">Return to Home</Link>
          <Link to="/faqs">FAQs</Link>
          <Link to="/shipping">Shipping Policy</Link>
          <Link to="/returns">Returns Policy</Link>
        </div>
      </div>
    </div>
  );
};

export default Contact;
